// extracted by mini-css-extract-plugin
export default {"icon":"_1o2-BqmAzdjpBJaqw5ltDn"};